import { IMAGE_EDGES, IMAGE_LIMITS } from './limits.mjs';

// Inside resize preserves aspect ratio. Integer raster dimensions may round
// the shorter edge down/up by at most one pixel, clamped to one for thin images.
// The longest edge is exact; a small master is never enlarged.
export function imageRenditionBounds(master, role) {
  if (
    !Number.isSafeInteger(master.width) ||
    !Number.isSafeInteger(master.height) ||
    master.width < 1 ||
    master.height < 1 ||
    master.width > IMAGE_LIMITS.maxDimension ||
    master.height > IMAGE_LIMITS.maxDimension
  )
    return null;
  if (role !== 'master' && !IMAGE_EDGES.includes(role)) return null;
  const edge = Math.max(master.width, master.height);
  const cap = role === 'master' ? edge : Math.min(edge, role);
  // Multiply bounded integers before division so the longest edge stays exact.
  const bounds = (dimension) => ({
    minimum: Math.max(1, Math.floor((dimension * cap) / edge)),
    maximum: Math.max(1, Math.ceil((dimension * cap) / edge)),
  });
  return { width: bounds(master.width), height: bounds(master.height) };
}
export function isImageRenditionGeometry(master, variant) {
  const bounds = imageRenditionBounds(master, variant.role);
  if (!bounds || !Number.isSafeInteger(variant.width) || !Number.isSafeInteger(variant.height))
    return false;
  return (
    variant.width >= bounds.width.minimum &&
    variant.width <= bounds.width.maximum &&
    variant.height >= bounds.height.minimum &&
    variant.height <= bounds.height.maximum
  );
}
